module.exports = __webpack_public_path__ + "static/media/logo-plus.4a99ae0a.svg";